import { configureStore } from '@reduxjs/toolkit'
import cartReducer from './cartSlice'
import byoReducer from './byoSlice'

export default configureStore({
  reducer: {
    cart: cartReducer,
    byo: byoReducer,
  },
})
